/**
 * @deprecated DO NOT USE THIS
 */
export const LUX_LOYALTY = {
  LANDING_PAGE: 'societe',
  DISMISS_JOIN_MODAL_STORAGE_KEY: 'luxLoyalty.dismissJoinModalWithExpiry',
} as const
